const verbose = true;

// const manageKey = 'chime_cache_json_mn';
const namePre = '_chime_lng_';
class LocalCache {
    static get(name) {
        let value = localStorage[namePre + name];
        if (!value) return;
        try {
            return JSON.parse(value);
        } catch (err) {
            verbose && console.log('Get Json Error:', name);
            return null;
        }
    }
    static set(name, content) {
        try {
            localStorage[namePre + name] = JSON.stringify(content);
        } catch (err) {
            verbose && console.log('Save Json Error:', name);
        }
    }
    static clear() {
        //how to limit: size? count?
    }
}

export default LocalCache;
